import { Text, Textarea } from '@mantine/core'
import { openConfirmModal } from '@mantine/modals'
import { ActionButton, AppModal } from '@/components/ui'

type TicketActionModalsProps = {
  resolveOpened: boolean
  resolving: boolean
  resolveConfirmationEnabled: boolean
  resolveComment: string
  helpOpened: boolean
  helpSending: boolean
  helpText: string
  onCloseResolve: () => void
  onChangeResolveComment: (value: string) => void
  onSubmitResolve: () => void
  onCloseHelp: () => void
  onChangeHelpText: (value: string) => void
  onSubmitHelp: () => void
}

export function TicketActionModals({
  resolveOpened,
  resolving,
  resolveConfirmationEnabled,
  resolveComment,
  helpOpened,
  helpSending,
  helpText,
  onCloseResolve,
  onChangeResolveComment,
  onSubmitResolve,
  onCloseHelp,
  onChangeHelpText,
  onSubmitHelp,
}: TicketActionModalsProps) {
  return (
    <>
      <AppModal
        opened={resolveOpened}
        onClose={onCloseResolve}
        title="Решить обращение"
        footer={
          <>
            <ActionButton action="cancel" onClick={onCloseResolve} disabled={resolving} />
            <ActionButton
              action="apply"
              loading={resolving}
              onClick={() => {
                if (!resolveConfirmationEnabled) {
                  onSubmitResolve()
                  return
                }
                openConfirmModal({
                  title: 'Подтвердить решение?',
                  children: (
                    <Text size="sm" c="dimmed">
                      Черновик ответа (если есть) будет отправлен клиенту, статус станет «Решено», вы вернётесь к
                      списку обращений.
                    </Text>
                  ),
                  labels: { confirm: 'Подтвердить', cancel: 'Отмена' },
                  confirmProps: { color: 'green' },
                  onConfirm: onSubmitResolve,
                })
              }}
            >
              Подтвердить
            </ActionButton>
          </>
        }
      >
        <Textarea
          label="Комментарий к решению"
          required
          minRows={4}
          value={resolveComment}
          onChange={(event) => onChangeResolveComment(event.currentTarget.value)}
        />
      </AppModal>

      <AppModal
        opened={helpOpened}
        onClose={onCloseHelp}
        title="Помощь коллег"
        footer={
          <>
            <ActionButton action="cancel" onClick={onCloseHelp} disabled={helpSending} />
            <ActionButton
              action="submit"
              loading={helpSending}
              onClick={() =>
                openConfirmModal({
                  title: 'Отправить запрос коллегам?',
                  children: (
                    <Text size="sm" c="dimmed">
                      Сообщение будет отправлено в канал помощи по этому обращению.
                    </Text>
                  ),
                  labels: { confirm: 'Отправить', cancel: 'Отмена' },
                  onConfirm: onSubmitHelp,
                })
              }
            >
              Отправить
            </ActionButton>
          </>
        }
      >
        <Textarea
          label="Сообщение"
          minRows={4}
          value={helpText}
          onChange={(event) => onChangeHelpText(event.currentTarget.value)}
        />
      </AppModal>
    </>
  )
}
